import $ from 'jquery';

$(document).ready(function() {
    function isMobile() {
        return window.innerWidth <= 768; // Проверка на мобильное устройство (можете изменить пороговое значение)
    }

    $('.ui-form-section__title--annotation').on('click', function(e) {
        if (isMobile()) {
            e.stopPropagation();

            var $textBlock = $(this).find('.ui-form-section__title--annotation-text');

            if ($textBlock.is(':visible')) {
                $textBlock.hide();
            } else {
                $('.ui-form-section__title--annotation-text').hide(); // Скрываем другие открытые блоки

                // Получаем размеры и позиции
                var windowWidth = $(window).width();
                var blockWidth = $textBlock.outerWidth();
                var elementOffset = $(this).offset();
                var elementWidth = $(this).outerWidth();

                // Центрирование блока и расчет позиции относительно нажатого элемента
                var leftPosition = (windowWidth - blockWidth) / 2 - elementOffset.left + (elementWidth / 2)-13;

                var topPosition =  35; // Смещение на 10px ниже элемента

                $textBlock.css({
                    'position': 'absolute',
                    'left': leftPosition + 'px',
                    'top': topPosition + 'px',
                    'display': 'block'
                });
            }
        }
    });

    // Скрытие блока при клике за его пределами
    $(document).on('click', function() {
        if (isMobile()) {
            $('.ui-form-section__title--annotation-text').hide();
        }
    });

    // Отключаем событие hover на мобильных устройствах
    if (isMobile()) {
        $('.ui-form-section__title--annotation').off('hover');
    }
});
